/**
 * Configuración de rangos USML
 *
 * Jerarquía completa de rangos disponibles en el sistema.
 * Sincronizado con web/src/shared/enum/ranks.ts
 */

/**
 * Rangos de fuerzas terrestres (Sable, Cratos)
 * Ordenados de mayor a menor jerarquía
 */
export const GROUND_RANKS = [
  'Sargento mayor',
  'Sargento 1ero',
  'Sargento',
  'Cabo 1ero',
  'Cabo Primero',
  'Cabo Segundo',
  'Cabo 2do',
  'Cabo',
  'Soldado de 1ra',
  'Soldado de 2da',
  'Soldado',
  'Cadete',
  'Recluta',
  'Aspirante'
];

/**
 * Rangos de fuerzas aéreas (Hades)
 * Ordenados de mayor a menor jerarquía
 */
export const AIR_RANKS = [
  'Senior Airman',
  'Airman First Class',
  'Airman',
  'Cadete',
  'Recluta',
  'Aspirante'
];

/**
 * Obtiene jerarquía de rangos para una rama
 *
 * @param {string} branchType - 'ground' o 'air'
 * @returns {Array<string>} Array de rangos ordenados
 */
export function getRankHierarchy(branchType) {
  return branchType === 'air' ? AIR_RANKS : GROUND_RANKS;
}

/**
 * Determina si una rama es terrestre o aérea
 *
 * @param {string} branch - Nombre de la rama (Sable, Hades, Cratos)
 * @returns {string} 'ground' o 'air'
 */
export function getBranchType(branch) {
  return branch === 'Hades' ? 'air' : 'ground';
}
